export const partnerVerificationsTag = 'partnerVerifications';
export const partnersTag = 'partners';
export const driversTag = 'drivers';
export const vehiclesTag = 'vehiclesTag';
